import InstantWinPrizeTable from "./instantWinPrizeTable.container";

export default InstantWinPrizeTable;
